import styled from 'styled-components';

export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  transition: box-shadow 0.3s ease;
  max-width: 240px;
  width: 100%;
  height: 300px;
  margin: 0 auto;
  justify-content: space-between;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 16px;

  img {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }

  svg {
    width: 48px;
    height: 48px;
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ $status }) => {
    if ($status?.toLowerCase() === 'enabled') return '#e7f3ff';
    if ($status?.toLowerCase() === 'disabled') return '#f5f5f5';
    return '#e7f3ff';
  }};
  color: ${({ $status }) => {
    if ($status?.toLowerCase() === 'enabled') return '#007bff';
    if ($status?.toLowerCase() === 'disabled') return '#6c757d';
    return '#007bff';
  }};
`;

export const Description = styled.p`
  font-size: 13px;
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
`;

export const ActionButton = styled.button`
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  height: 32px;
  width: 98px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $delete }) => ($delete ? '#FB2C36' : '#2D6CDF')};

  &:hover {
    background-color: ${({ $delete }) => ($delete ? '#fff5f5' : '#f0f5ff')};
    border-color: ${({ $delete }) => ($delete ? '#FB2C36' : '#2D6CDF')};
  }

  &:active {
    transform: scale(0.98);
  }
`;
